module.exports = __webpack_public_path__ + "static/media/emailSentIcon.2bb97997.svg";